var _span, _People, _span2, _Pin, _Link, _Copy;
import cn from 'clsx';
import { differenceInMinutes } from 'date-fns';
import Copy from '@crehana/compass.icons.outline/Copy';
import Link2 from '@crehana/compass.icons.outline/Link2';
import People from '@crehana/compass.icons.outline/People';
import Pin from '@crehana/compass.icons.outline/Pin';
import { TooltipWrapper } from '@crehana/compass.ui';
import { Button } from '@crehana/compass.ui/v2';
import { useLiveSessionsTranslation } from "../../hooks/useLiveSessionsTranslation";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var NextLiveSession = function NextLiveSession(_ref) {
  var session = _ref.session,
    isHome = _ref.isHome,
    isAdmin = _ref.isAdmin,
    organizationSlug = _ref.organizationSlug;
  var _useLiveSessionsTrans = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans.t;
  var title = session.title,
    guests = session.guests,
    startDate = session.startDate,
    endDate = session.endDate;
  var minutesToSession = differenceInMinutes(startDate, new Date());

  // The session is live
  var isLive = minutesToSession < 0 && endDate > new Date();

  // The session will start in less than 30 minutes
  var isStartingInLessThan30Minutes = minutesToSession <= 30;
  if (!isLive && !isStartingInLessThan30Minutes) return null;
  var handleCopyToClipboard = function handleCopyToClipboard() {
    if (session.type === 'virtual') navigator.clipboard.writeText(session.link);
  };
  var gotToSessionLink = function gotToSessionLink(link) {
    window.open("".concat(link), '_blank');
  };
  var goToSessionDetail = function goToSessionDetail() {
    var baseUrl = window.location.origin;
    if (isAdmin) {
      return window.open("".concat(baseUrl, "/org/").concat(organizationSlug, "/panel/content/lives/").concat(session.id, "/"));
    }
    return window.open("".concat(baseUrl, "/org/").concat(organizationSlug, "/live-sessions/").concat(session.id, "/"), '_blank');
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-w-full tw-flex tw-flex-col tw-justify-between tw-bg-primary-light-500 tw-rounded-2 tw-p-2.4 tw-space-y-14.4 sm:tw-space-y-3.2",
    children: [isLive ? /*#__PURE__*/_jsxs("div", {
      className: "tw-font-label2 tw-text-on-hold-500 tw-bg-on-hold-100 tw-rounded-2 tw-flex tw-items-center tw-gap-1.2 tw-w-fit tw-px-1 tw-py-0.4",
      children: [_span || (_span = /*#__PURE__*/_jsx("span", {
        className: "tw-w-1.2 tw-h-1.2 tw-rounded-full tw-bg-on-hold-500"
      })), t('SESSION_LIVE_TAG')]
    }) : /*#__PURE__*/_jsx("div", {
      className: "tw-block tw-w-full tw-font-label2 tw-mb-3.2 tw-text-neutral-light-100",
      children: t('SESSION_START_IN', {
        interpolation: {
          min: minutesToSession
        }
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: cn('tw-flex tw-justify-between tw-gap-1.2 tw-flex-col', !isHome && 'tw-flex-col sm:tw-flex-row sm:tw-items-center'),
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h3", {
          className: cn('tw-font-subtitle2 tw-text-neutral-light-100 tw-mb-1.2', isHome ? 'tw-text-2.4' : 'tw-text-2'),
          children: title
        }), /*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-items-center tw-gap-1.2 tw-font-body4 tw-text-neutral-light-100",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "tw-flex tw-items-center tw-gap-0.8 tw-order-3 sm:tw-order-1",
            children: [_People || (_People = /*#__PURE__*/_jsx(People, {
              size: 16,
              className: "tw-text-neutral-light-100"
            })), /*#__PURE__*/_jsx("span", {
              className: isHome ? 'tw-hidden' : 'tw-hidden sm:tw-block',
              children: /*#__PURE__*/_jsx("p", {
                className: "tw-line-clamp-1",
                children: t('DATE_SESSIONS_CARD_GUESTS', {
                  interpolation: {
                    guests: guests
                  }
                })
              })
            }), /*#__PURE__*/_jsx("span", {
              className: isHome ? 'tw-block' : 'tw-block sm:tw-hidden',
              children: guests
            })]
          }), _span2 || (_span2 = /*#__PURE__*/_jsx("span", {
            className: "tw-order-2",
            children: "|"
          })), /*#__PURE__*/_jsx("div", {
            className: "tw-flex tw-items-center tw-gap-0.8 tw-order-1 sm:tw-order-3",
            children: session.type === 'location' ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [_Pin || (_Pin = /*#__PURE__*/_jsx(Pin, {
                className: "tw-m-0.4 tw-shrink-0",
                size: 16
              })), /*#__PURE__*/_jsx("p", {
                className: "tw-line-clamp-1",
                children: session.address
              })]
            }) : /*#__PURE__*/_jsxs(_Fragment, {
              children: [_Link || (_Link = /*#__PURE__*/_jsx(Link2, {
                className: "tw-m-0.4 tw-shrink-0",
                size: 16
              })), /*#__PURE__*/_jsx("p", {
                className: "tw-line-clamp-1",
                children: t('SESSION_CARD_LINK_PLACEHOLDER')
              }), /*#__PURE__*/_jsx(TooltipWrapper, {
                message: t('COPY_LINK'),
                position: "top",
                sectionClassName: "tw-bg-neutral-light-200 tw-text-neutral-light-800",
                children: /*#__PURE__*/_jsx("button", {
                  className: "tw-flex tw-items-center",
                  type: "button",
                  onClick: handleCopyToClipboard,
                  children: _Copy || (_Copy = /*#__PURE__*/_jsx(Copy, {
                    className: "tw-m-0.4 tw-shrink-0",
                    size: 20
                  }))
                })
              })]
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: cn('tw-flex tw-flex-col tw-items-center tw-gap-1.6 sm:tw-gap-2.4', isHome ? 'sm:tw-flex-row' : 'sm:tw-flex-row-reverse'),
        children: [session.type === 'virtual' && /*#__PURE__*/_jsx(Button, {
          type: "submit",
          variant: "white",
          size: "sm",
          disabled: !isLive,
          className: cn('tw-w-full sm:tw-w-fit', isHome && 'sm:tw-mb-1.2'),
          onClick: function onClick() {
            return gotToSessionLink(session.link);
          },
          children: /*#__PURE__*/_jsx("span", {
            className: "tw-w-full tw-text-center ",
            children: t('GET_INTO')
          })
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: cn('tw-font-subtitle5 tw-text-neutral-light-100', isHome && 'sm:tw-mb-1.2'),
          onClick: function onClick() {
            return goToSessionDetail();
          },
          children: t('SESSION_CARD_CTA_DETAIL')
        })]
      })]
    })]
  });
};